import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { UserDto } from './user.dto';

export class AreaDto extends BaseDto {
  cityId: number;
  managerUserId: number;
  merchantGroup: MerchantGroupDto;
  merchantGroupId: number;
  managerUser: UserDto;
  name: string;
  startDate?: Date;
  endDate?: Date;
}
